/* ==========================================================================
   TANJORE — ADD TO CART PILLS
   Added 2026-09-26.

   Two jobs, both of which have to happen in the browser rather than in Liquid.

   1. FILL THE "SHIPS …" LINE IN PILL 2
      The message is computed against IST in the visitor's browser, exactly as
      the liquid_wVybHL block in templates/product.json always did it. It cannot
      move into snippets/buy-buttons.liquid: Prestige re-renders that block on
      every variant change, and a <script> arriving through innerHTML never
      executes, so the line would go blank as soon as someone picked another
      colour.

   2. MIRROR PILL 1 INTO THE STICKY BAR
      The sticky bar carries its OWN copy of the pill markup, captured
      separately in sections/main-product.liquid — which is why its button has
      no .w-full class and sits in no .atc-price-row wrapper. Editing that 66KB
      section would leave the pill's contents defined in two places that then
      have to be kept in step by hand. Copying from the rendered main pill keeps
      one source of truth: the wording, the rupee sign and the strikethrough are
      all decided once, in buy-buttons.liquid, and carried across from there.
   ========================================================================== */

(function () {
  'use strict';

  /* ------------------------------------------------------------------------
     Ships message. Cutoffs carried over unchanged from liquid_wVybHL: weekdays
     dispatch until 10:45 IST, Saturday until 11:00, Sunday not at all.
     ------------------------------------------------------------------------ */
  function shipsMessage() {
    var nowUTC = new Date();
    var istOffsetMs = (5 * 60 + 30) * 60 * 1000;
    var ist = new Date(nowUTC.getTime() + nowUTC.getTimezoneOffset() * 60000 + istOffsetMs);
    var day = ist.getDay();
    var mins = ist.getHours() * 60 + ist.getMinutes();
    var weekdayCutoff = 10 * 60 + 45;
    var satCutoff = 11 * 60;

    if (day === 0) {
      return 'Ships Monday';
    }

    if (day === 6) {
      return mins < satCutoff ? 'Ships Today' : 'Ships Monday';
    }

    return mins < weekdayCutoff ? 'Ships Today' : 'Ships Tomorrow';
  }

  function fillShips() {
    var msg = shipsMessage();
    var nodes = document.querySelectorAll('[data-atc-ships]');
    var i;

    for (i = 0; i < nodes.length; i++) {
      /* Only write when the text actually differs. Writing unconditionally
         would re-trigger the observer below on every pass, forever. */
      if (nodes[i].textContent !== msg) {
        nodes[i].textContent = msg;
      }
    }
  }

  /* Small helper so every write is guarded the same way. */
  function setText(el, text) {
    if (el && el.textContent !== text) {
      el.textContent = text;
    }
  }

  /* ------------------------------------------------------------------------
     Sticky bar pill 1.

     Main pill 1 reads "Add to Cart ₹2,239" over a struck-through compare-at
     price. The sticky pill is brought in line with it:

       - its price line is copied across verbatim, so the rupee sign and the
         dropped dash from buy-buttons.liquid follow through without touching
         sections/main-product.liquid's own copy of the capture;
       - its "Free Shipping" line gives way to the same strikethrough.

     On a product with no compare-at price there is nothing to strike through,
     so the sticky pill keeps its Free Shipping line rather than losing its
     second line altogether. The main pill needs no such fallback — its Free
     Shipping moved into pill 2, which the sticky bar has no room for.
     ------------------------------------------------------------------------ */
  function mirrorStickyPill() {
    var stickyButton = document.querySelector('.product-sticky-bar buy-buttons.atc-sticky-pill .button');

    if (!stickyButton) {
      return;
    }

    /* Price line first, and independently of the compare-at price below — a
       product with no sale price still needs the rupee sign and the wording. */
    var sourcePrice = document.querySelector('.atc-price-row .atc-pill1-price');
    var stickyPrice = stickyButton.querySelector('.atc-pill1-price');

    if (sourcePrice && stickyPrice) {
      setText(stickyPrice, sourcePrice.textContent);
    }

    var sourceCompare = document.querySelector('.atc-price-row .atc-pill1-compare');
    var stickyFreeship = stickyButton.querySelector('.atc-pill1-freeship');
    var stickyCompare = stickyButton.querySelector('.atc-pill1-compare');

    if (!sourceCompare) {
      if (stickyCompare) {
        stickyCompare.remove();
      }

      return;
    }

    if (stickyFreeship) {
      stickyFreeship.remove();
    }

    if (!stickyCompare) {
      stickyCompare = document.createElement('s');
      stickyCompare.className = 'atc-pill1-compare';
      stickyButton.appendChild(stickyCompare);
    }

    setText(stickyCompare, sourceCompare.textContent);
  }

  function apply() {
    fillShips();
    mirrorStickyPill();
  }

  /* ------------------------------------------------------------------------
     Run now, and again whenever Prestige swaps a block out. A variant change
     re-renders both the buy-buttons block and the sticky bar, which wipes the
     ships placeholder and restores the sticky bar's own price wording and Free
     Shipping line. Every write above is guarded by an equality check, so
     re-running on our own mutations settles after a single pass instead of
     looping.
     ------------------------------------------------------------------------ */
  function watch() {
    apply();

    var targets = [
      document.querySelector('.product-info'),
      document.querySelector('.product-sticky-bar')
    ];
    var i;

    for (i = 0; i < targets.length; i++) {
      if (targets[i]) {
        new MutationObserver(apply).observe(targets[i], { childList: true, subtree: true });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
